import { createActions, createReducer } from "reduxsauce";

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    sustainabilityStep: [''],

    fileCertificateSustainability: [''],

    fileStep: [''],

    tradeConciliation: ["payload"],

    taxConciliation: ["payload"],

    resetReconcile: [''],

    resultStep: [false]
});

/**
 * Handlers
 */
const INITIAL_STATE = {
    sustainabilityStep: '',
    fileStep: '',
    tradeConciliation: '',
    taxConciliation: '',
    resultStep: false
};

const resultStep = (state = INITIAL_STATE, action) => {
    return { ...state, resultStep: action.resultStep };
};

const sustainabilityStep = (state = INITIAL_STATE, action) => {
    return { ...state, sustainabilityStep: action.sustainabilityStep };
};

const fileStep = (state = INITIAL_STATE, action) => {
    return { ...state, fileStep: action.fileStep };
};

const tradeConciliation = (state = INITIAL_STATE, action) => {
    return { ...state, tradeConciliation: action.payload };
};

const taxConciliation = (state = INITIAL_STATE, action) => {
    return { ...state, taxConciliation: action.payload };
};

const resetReconcile = (state = INITIAL_STATE) => {
	return INITIAL_STATE
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SUSTAINABILITY_STEP]: sustainabilityStep,
    [Types.FILE_STEP]: fileStep,
    [Types.TRADE_CONCILIATION]: tradeConciliation,
    [Types.TAX_CONCILIATION]: taxConciliation,
    [Types.RESET_RECONCILE]: resetReconcile,
    [Types.RESULT_STEP]: resultStep
});
